<div class="content-padding">
  <div class="wordpress" [innerHTML]="page?.content?.rendered"></div>
  <div *ngIf="!page?.content?.rendered && !loading" class="input-error">ERROR: No WP content</div>
</div>
<a class="app-link" href="https://laax.app.link/live">
  <img *ngIf="restaurantId == 2" src="/assets/img/laax-app.png">
</a>